import enums from "./enums";
import common from "./common";
import assets from "./assets";
import map from "./map";
import account from "./account";
import inquiry from "./inquiry";

export default { enums, common, assets, map, account, inquiry };
